import { Injectable } from '@angular/core';

import { SandboxPage } from '../model/page/sandbox-page';
import { Booking } from '../model/screen/your-booking-screen';

@Injectable({
  providedIn: 'root'
})
export class SandboxPageStateHelperService {
  constructor() {}

  updateSandboxDataSource(sandboxPage: SandboxPage, sandboxData: any): SandboxPage {
    sandboxPage.passengerIndex = sandboxData.passengerIndex;
    if (typeof sandboxData.hideSideMenu !== 'undefined') {
      sandboxPage.sandboxMenu.hideSideMenu = sandboxData.hideSideMenu;
    }
    if (typeof sandboxData.widthMainMenu !== 'undefined') {
      sandboxPage.sandboxMenu.widthMainMenu = sandboxData.widthMainMenu;
    }
    if (typeof sandboxData.sideMenu !== 'undefined') {
      sandboxPage.sandboxMenu.sideMenu = sandboxData.sideMenu;
      if (sandboxPage.sandboxMenu.hideSideMenu === 'Yes') {
        sandboxPage.sandboxMenu.hideSideMenu = 'No';
      }
    }
    if (typeof sandboxData.mainMenu !== 'undefined') {
      sandboxPage.sandboxMenu.mainMenu = sandboxData.mainMenu;
    }
    if (typeof sandboxData.showError !== 'undefined') {
      sandboxPage.sandboxMenu.showError = sandboxData.showError;
      if (sandboxData.showError === 'Yes') {
        sandboxPage.sandboxMenu.errorMessage = sandboxData.errorMessage;
      } else {
        sandboxPage.sandboxMenu.errorMessage = '';
      }
    }

    if (typeof sandboxData.showSuccess !== 'undefined') {
      sandboxPage.sandboxMenu.showSuccess = sandboxData.showSuccess;
      if (sandboxData.showSuccess === 'Yes') {
        sandboxPage.sandboxMenu.successMessage = sandboxData.successMessage;
      } else {
        sandboxPage.sandboxMenu.successMessage = '';
      }
    }
    if (typeof sandboxData.showWarning !== 'undefined') {
      sandboxPage.sandboxMenu.showWarning = sandboxData.showWarning;
      if (sandboxData.showWarning === 'Yes') {
        sandboxPage.sandboxMenu.warningMessage = sandboxData.warningMessage;
      } else {
        sandboxPage.sandboxMenu.warningMessage = '';
      }
    }
    if (typeof sandboxData.disableOfferFilter !== 'undefined') {
      sandboxPage.sandboxMenu.disableOfferFilter = sandboxData.disableOfferFilter;
    }
    if (typeof sandboxData.searchFlightFormValue !== 'undefined') {
      sandboxPage.searchFlightFormValue = sandboxData.searchFlightFormValue;
    }
    if (typeof sandboxData.findOrderFormValue !== 'undefined') {
      sandboxPage.findOrderFormValue = sandboxData.findOrderFormValue;

      if (typeof sandboxData.bookingReferences !== 'undefined') {
        sandboxPage.bookingReferences = sandboxData.bookingReferences;
      }
    }

    return sandboxPage;
  }
}
